module.exports = __webpack_public_path__ + "img/a48fac3.jpg";